export interface Point {
  x: number,
  y: number
}

export interface Rectangle extends Point {
  x: number,
  y: number,
  width: number,
  height: number
}

export interface StreamInfoInterface {
  label: string,
  is_default: boolean,
  codec: string,
  height: number,
  width: number,
  stream_id: string
}

export interface CameraDataInterface {
  can_browse: boolean
  can_export_bookmarks: boolean
  can_export_video: true
  gps_lat: string
  gps_long: string
  id: string
  name: string
  playback_limit_hours: any
  ptz: boolean
  state: string
  streams: StreamInfoInterface[]
  triggers: [],
  currentStream: StreamInfoInterface | null
}

export interface StreamDataInterface {
  label: string,
  is_default: boolean,
  codec: string,
  height: number,
  width: number,
  stream_id: string
}

export type RotScaleInterface = {
  rotation: number,
  scale: number
} | null

export enum Routes {
  live = '/live',
  browse = '/browse',
  bookmarks = '/bookmarks',
  alerts = '/alerts'
}

export type Override<T, U> = Omit<T, keyof U> & U;

export const isPresentObject = <T>(arg: T | any): arg is T => arg && Object.keys(arg).length > 0
